<style scoped>
  .name{font-size: 18px;color: #464c5b;font-weight: bolder;}
  .team{font-size: 14px;color: #657180;margin-top: 15px;}
  .tuhuogonggao{width: 21px;height: 20px;vertical-align: top;}
  .lawNotice{font-size: 14px;color: #464c5b;font-weight: bolder;border-right: 1px solid #d7dde4;margin-right: -12px;display: flex;align-items: center;height: 56px;}
  .wordsNotice{font-size: 14px;color: #657180;line-height: 30px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .iconset{width: 16px;height: 16px;vertical-align: top;margin-right: 10px;}
  .see{display: inline-block;font-size: 14px;color: #00a2e9; margin-top: -2px;}
  .projectApproval{font-size: 16px;color: #464c5b;font-weight:bold;margin: 35px 0 24px 0;}
  .contentClass{color: #657180;font-size: 14px}
  .tab >>> .ivu-tabs-nav{line-height: 60px;margin-left:30px;}
  .tab >>>.ivu-tabs-tab{line-height: 60px;}
  .tab >>> .ivu-tabs-bar{margin-bottom: 0;}
</style>
<template>
  <div class="home">
    <Modal
        v-model="noticePanel.state"
        title="公告详情"
        ok-text="知道了"
    >
      <Row>
        <Col span="4" style="text-align: right;">公告标题：</Col>
        <Col span="19"><p>{{noticePanel.title}}</p></Col>
      </Row>
      <div style="padding: 10px;"></div>
      <Row>
        <Col span="4" style="text-align: right;">公告时间：</Col>
        <Col span="19"><p>{{noticePanel.updateDate}}</p></Col>
      </Row>
      <div style="padding: 10px;"></div>
      <Row>
        <Col span="4" style="text-align: right;">公告内容：</Col>
        <Col span="19" v-html="noticePanel.content"></Col>
      </Row>
    </Modal>
    <Row type="flex" justify="end" class="code-row-bg" style="background-color: #fff;height: 100px;border-left: 2px solid #00a2e9;margin-bottom: 40px;">
      <Col span="9" style="display: inherit;align-items: center;">
        <!--头像-->
        <Col span="4">
          <Avatar :src="userIcon?userIcon:'https://i.loli.net/2017/08/21/599a521472424.jpg'" size="large" style="width: 66px;height: 66px;border-radius: 32px;"/>
        </Col>
        <!--名称、团队-->
        <Col span="20" style="vertical-align: top;">
          <p class="name">下午好，<span style="color:red">{{fullName}}</span></p>
          <p class="team">{{$store.state.userInfo.companyName}}</p>
        </Col>
      </Col>
      <Col span="14" style="display: flex;align-items: center;">
        <Col span="1">
          <img class="tuhuogonggao" src="/img/home/tuhuogonggao.png" />
        </Col>
        <Col span="1" >
          <div class="lawNotice">律所 公告</div>
        </Col>
        <Col span="18" style="padding-left: 24px;">
          <div class="wordsNotice" v-for="(item,index) in noticeList">
            <span @click="noticePanel.state=true;noticePanel.title=item.title;noticePanel.updateDate=item.updateDate;noticePanel.content=item.content;noticePanel.id=item.id">{{item.title}}</span>
            <span style="font-size:12px;color:#bbb"> ({{item.updateDate}})</span>
          </div>
        </Col>
        <Col span="4" style="cursor:pointer;">
          <router-link :to="{name:'settingNotice'}">
            <img class="iconset" src="/img/home/iconset.png" />
            <p class="see">查看更多</p>
          </router-link>
        </Col>
      </Col>
    </Row>
    <!---->
    <Row :gutter="40" class="tab" style="max-width: 1200px;">
      <Col span="16" >
        <Tabs value="0" style="background-color: white;min-height:730px">
          <TabPane :label="taskData[0].name" name="0">
            <Row type="flex" justify="center">
              <Col span="22" v-for="(item,index) in taskData[0].list" style="border-bottom: 1px solid #d7dde4">
                <router-link style="width: 100%" :to="{name:'projectTask',query:{caseId:item.id,taskId:item.taskId,filed:item.filed}}">
                <Col span="22" style="margin-left: 20px;" class="projectApproval">
                  {{item.name}}
                </Col>
                <Col span="24" style="margin-left: 20px;padding-bottom:30px">
                  <!--<Col span="8" class="contentClass">创建人：{{item.createPeople}} </Col>-->
                  <Col span="10" class="contentClass">创建时间：{{item.createDate}} </Col>
                  <Col span="8" class="contentClass">当前进度：{{item.completed}}/{{item.missionTotal}}</Col>
                </Col>
                </router-link>
              </Col>
              <Col span="22" style="margin:40px 0 57px 0;text-align:center">
                <Button v-if="taskData[0].list.length>=5" type="primary" style="width:150px" @click="$router.push({name:'projectList'})">查看更多</Button>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="taskData[1].name" name="1">
            <Row type="flex" justify="center">
              <Col span="22" v-for="(item,index) in taskData[1].list" style="border-bottom: 1px solid #d7dde4">
                <router-link style="width: 100%" :to="{name:'approvalHandle'}">
                  <Col span="22" style="margin-left: 20px;" class="projectApproval">
                    {{item.name}}
                  </Col>
                  <Col span="24" style="margin-left: 20px;padding-bottom:30px">
                    <!--<Col span="8" class="contentClass">创建人：{{item.createPeople}} </Col>-->
                    <Col span="10" class="contentClass">所属项目：{{item.projectName}} </Col>
                    <Col span="8" class="contentClass">创建时间：{{item.createDate}}</Col>
                  </Col>
                </router-link>
              </Col>
              <Col span="22" style="margin:40px 0 57px 0;text-align:center">
                <Button type="primary" v-if="taskData[1].list.length>=5" style="width:150px" @click="$router.push({name:'approvalHandle'})">查看更多</Button>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="taskData[2].name" name="2">
            <Row type="flex" justify="center">
              <Col span="22" v-for="(item,index) in taskData[2].list" style="border-bottom: 1px solid #d7dde4">
                <router-link style="width: 100%" :to="{name:'approvalSubmission'}">
                  <Col span="22" style="margin-left: 20px;" class="projectApproval">
                    {{item.name}}
                  </Col>
                  <Col span="24" style="margin-left: 20px;padding-bottom:30px">
                    <!--<Col span="8" class="contentClass">创建人：{{item.createPeople}} </Col>-->
                    <Col span="10" class="contentClass">所属项目：{{item.projectName}} </Col>
                    <Col span="8" class="contentClass">创建时间：{{item.createDate}}</Col>
                  </Col>
                </router-link>
              </Col>
              <Col span="22" style="margin:40px 0 57px 0;text-align:center">
                <Button type="primary" v-if="taskData[2].list.length>=5" style="width:150px" @click="$router.push({name:'approvalSubmission'})">查看更多</Button>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="taskData[3].name" name="3">
            <Row type="flex" justify="center">
              <Col span="22" v-for="(item,index) in taskData[3].list" style="border-bottom: 1px solid #d7dde4">
                <router-link style="width: 100%" :to="{name:'projectTask',query:{caseId:item.id,taskId:item.taskId}}">
                  <Col span="22" style="margin-left: 20px;" class="projectApproval">
                    {{item.name}}
                  </Col>
                  <Col span="24" style="margin-left: 20px;padding-bottom:30px">
                    <!--<Col span="8" class="contentClass">创建人：{{item.createPeople}} </Col>-->
                    <Col span="10" class="contentClass">创建时间：{{item.createDate}} </Col>
                    <Col span="8" class="contentClass">当前进度：{{item.completed}}/{{item.missionTotal}}</Col>
                  </Col>
                </router-link>
              </Col>
              <Col span="22" style="margin:40px 0 57px 0;text-align:center">
                <Button type="primary" v-if="taskData[2].list.length>=5" style="width:150px" @click="$router.push({name:'projectList'})">查看更多</Button>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="taskData[4].name" name="4">
            <Row type="flex" justify="center">
              <Col span="22" v-for="(item,index) in taskData[3].list" style="border-bottom: 1px solid #d7dde4">
                <router-link style="width: 100%" :to="{name:'projectTask',query:{caseId:item.id,taskId:item.taskId}}">
                  <Col span="22" style="margin-left: 20px;" class="projectApproval">
                    {{item.name}}
                  </Col>
                  <Col span="24" style="margin-left: 20px;padding-bottom:30px">
                    <!--<Col span="8" class="contentClass">创建人：{{item.createPeople}} </Col>-->
                    <Col span="10" class="contentClass">创建时间：{{item.createDate}} </Col>
                    <Col span="8" class="contentClass">当前进度：{{item.completed}}/{{item.missionTotal}}</Col>
                  </Col>
                </router-link>
              </Col>
              <Col span="22" style="margin:40px 0 57px 0;text-align:center">
                <Button type="primary" v-if="taskData[2].list.length>=5" style="width:150px" @click="$router.push({name:'projectList'})">查看更多</Button>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      </Col>
      <Col span="8">
        <!--日历-->
        <calendar></calendar>
      </Col>
      <Col span="8" style="margin-top: 40px;">
        <!--便签-->
        <note></note>
      </Col>
    </Row>
  </div>
</template>

<script>
  import calendar from "../components/system/calendar";
  import note from "../components/system/note";

  export default {
    components: {calendar,note},
    name: 'home',//系统首页
    data() {
      return {
        taskData: [
          {
            name: '我的任务',
            list:[],
            // label:(h)=>{
            //   return h('div', [
            //     h('span', '我的任务'),
            //     h('Badge', {
            //       props: {
            //         count:3
            //       }
            //     })
            //   ])
            // }
          },
          {name: '待我审批',list:[],},
          {name: '发起的审批',list:[],},
          {name: '即将到期任务',list:[],},
          {name: '超时任务',list:[],}
        ],
        noticePanel:{
          state:false,
          content:"",
          title:"",
          id:'',
        },
        noticeList:[]
      }
    },
    methods: {
      getNotice:function(){
        var _this = this
        _this.noticeList = []
        _this.send({
          headers:'NO/ShowNotice',
          data:{
            pageSize : 2,
          },
          warningTips:false,
          success:function (res) {
            for(var index in res.list){
              _this.noticeList.push({
                id:res.list[index].NoticeId,
                title:res.list[index].NoticeTitle,
                content:res.list[index].NoticeContent,
                createDate:res.list[index].NoticeCreatedTime,
                updateDate:res.list[index].NoticeUpdateTime,
              })
            }
          }
        })
      },
      getList:function () {
        var _this = this
        _this.taskData[0].list = []
        _this.taskData[1].list = []
        _this.taskData[2].list = []
        _this.taskData[3].list = []
        _this.taskData[4].list = []
        _this.send({
          headers:'X/ShowIndex',
          warningTips:false,
          data:{
            temp:1,
						pageSize:5,
          },
          success:function (res) {
            for(var index in res.list){
              _this.taskData[0].list.push({
                name:res.list[index].CaseTitle,
                id:res.list[index].CaseId,
                taskId:res.list[index].MissionId,
                createDate:res.list[index].CaseCreateTime,
                seal:res.list[index].Visa,
                completed:res.list[index].MissionComplete,
                missionTotal:res.list[index].MissionCount,
              })
              if(_this.taskData[0].list.length>4){
                return
              }
            }
          }
        })
        _this.send({
          headers:'X/ShowIndex',
          warningTips:false,
          data:{
            temp:2,
						pageSize:5,
          },
          success:function (res) {
            for(var index in res.list){
              _this.taskData[1].list.push({
                name:res.list[index].ApprovalModeTitle,
                projectName:res.list[index].CaseTitle,
                id:res.list[index].ApprovalId,
                createDate:res.list[index].CaseCreateTime,

              })
              if(_this.taskData[1].list.length>4){
                return
              }
            }
          }
        })
        _this.send({
          headers:'X/ShowIndex',
          warningTips:false,
          data:{
            temp:3,
						pageSize:5,
          },
          success:function (res) {
            for(var index in res.list){
              _this.taskData[2].list.push({
                name:res.list[index].ApprovalModeTitle,
                projectName:res.list[index].CaseTitle,
                id:res.list[index].ApprovalId,
                createDate:res.list[index].CaseCreateTime,
              })
              if(_this.taskData[2].list.length>4){
                return
              }
            }
          }
        })
        _this.send({
          headers:'X/ShowIndex',
          warningTips:false,
          data:{
            temp:4,
						pageSize:5,
          },
          success:function (res) {
            for(var index in res.list){
              _this.taskData[3].list.push({
                name:res.list[index].CaseTitle,
                id:res.list[index].CaseId,
                taskId:res.list[index].MissionId,
                createDate:res.list[index].CaseCreateTime,
                completed:res.list[index].MissionComplete,
                missionTotal:res.list[index].MissionCount,
              })
              if(_this.taskData[3].list.length>4){
                return
              }
            }
          }
        })
        _this.send({
          headers:'X/ShowIndex',
          warningTips:false,
          data:{
            temp:5,
						pageSize:5,
          },
          success:function (res) {
            for(var index in res.list){
              _this.taskData[4].list.push({
                name:res.list[index].CaseTitle,
                id:res.list[index].CaseId,
                taskId:res.list[index].MissionId,
                createDate:res.list[index].CaseCreateTime,
                completed:res.list[index].MissionComplete,
                missionTotal:res.list[index].MissionCount,
              })
              if(_this.taskData[4].list.length>4){
                return
              }
            }
          }
        })
      }
    },
    mounted:function () {
      if(SYSCONFIG.server.default.data.UserToken==''){
        this.$router.push({name:'login'})
      }else{
        this.$store.state.userInfo.icon = window.sessionStorage.userIcon
        this.$store.state.userInfo.groupName = window.sessionStorage.groupName
        this.$store.state.userInfo.companyName = window.sessionStorage.companyName
        this.$store.state.userInfo.fullName = window.sessionStorage.fullName
        this.$store.state.userInfo.companyShortName = window.sessionStorage.companyShortName
        this.getList()
        this.getNotice()
      }
    },
    computed:{
      fullName:function () {
        return this.$store.state.userInfo.fullName
      },
      userIcon:{
        get:function(){
          return this.$store.state.userInfo.icon
        }
      }
    }
  }
</script>
